module.exports = __webpack_public_path__ + "static/media/eye.bdc5b71f.svg";